module.exports = __webpack_public_path__ + "static/media/Logo-l-primaryColor.308923c4.svg";